export default "__VITE_ASSET__BBa0zpPb__"